/**
 *    @author:
 *    @since:
 *
 */
import { ViewportScroller } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { Contact, InputData } from '../_common/data/input-data';
import { Path, Progress } from  "../_common/constant/page-const";
import { ContactInfoAndMailingAddressValidation } from './contact_info_and_mailing_address.validator';
import { CanadaAddressComponent } from './canada-address/canada-address.component';
import { InternationalAddressComponent } from './international-address/international-address.component';
import { ItemList } from '../_common/constant/item-list';
import { Confirm, Country } from 'src/refresh/service/constant';
import { PostalCodeLookup } from 'src/refresh/service/postalCode-service';
import { MailAddressChoice } from 'src/app/_common/data/lookup-data';
import { LightBox } from 'src/refresh/layout/light-box/light-box.component';
import { Util } from 'src/refresh/service/Util';
import { ProgressService } from 'src/refresh/service/progress-service';
import { RadioComponent } from 'src/refresh/form-control/radio/radio.component';

@Component({
      selector: 'contact_info_and_mailing_address',
      templateUrl: './contact_info_and_mailing_address.component.html',
      styleUrls: ['./contact_info_and_mailing_address.component.less']
})
export class ContactInfoAndMailingAddressComponent extends FormBaseComponent implements OnInit {

      public contact: Contact;
      public motherContact: Contact;

      public  postalCode;
      private isCodeLookup:boolean = false;

      public parentNameParam: Object;
      public postalCodeParam: Object;
      public isPostalCodeValid: string;
      public isCanadianAddress: string;

      public error_phoneNumber: string = "";
      public error_intPhoneNumber: string = "";
      public error_daytimePhoneNumber: string = "";
      public error_intDaytimePhoneNumber: string = "";
      public error_sameAddress: string = "";
      public error_selectAddrType: string = "";
      public error_postalCode: string = "";
      public error_selectRange: string = "";
      public notEditable: boolean;

      @ViewChild('canadaAddr') canadaAddr: CanadaAddressComponent;
      @ViewChild('internAddr') internAddr: InternationalAddressComponent;
      @ViewChild('parentCanadaAddr') parentCanadaAddr: CanadaAddressComponent;
      @ViewChild('parentInternAddr') parentInternAddr: InternationalAddressComponent;
      @ViewChild(LightBox) box1: LightBox;

      @ViewChild('list') list: RadioComponent;

      public rangeList: Map<string, string> = new Map();
      public selectedRange: string = "";
      public availableList: MailAddressChoice[];

      private addressValidator:ContactInfoAndMailingAddressValidation;

      constructor(protected router: Router,
            public timerService: TimerService,
            protected progress:ProgressService,
            public items: ItemList,
            public data: InputData,
            public viewportScroller: ViewportScroller,
            public postal: PostalCodeLookup) {

            super(router,timerService);  
            
            let prevParent = Path.AboutTheParentsScreen + this.data.eligibility.listedParentCount;

            super.setNextPage(Path.FinalReview,prevParent);

            this.addressValidator = new ContactInfoAndMailingAddressValidation(this,Progress.AboutParent);
            super.setValidator(this.addressValidator);

            this.contact = data.contact;
            this.motherContact = data.motherContact;

            let motherName: string = '';

            if (this.data.eligibility.isBornThroughSurrogacy == Confirm.NO)
                  motherName = data.getBirthParent().name.getFullName();
            else {
                  this.data.motherContact.address.chk_international = '';
                  this.contact.isParentSameAddr = '';
            }

            this.parentNameParam = { birthParentName: motherName };
            this.postalCodeParam = { postalCode: this.contact.address.postalCode };

            if (this.data.motherContact.address.chk_international == 'Y') {
                  this.isCanadianAddress = "4100";
            } else if (this.data.motherContact.address.chk_international == 'N') {
                  this.isCanadianAddress = "1700";
            } else {
                  this.isCanadianAddress = '';
            }

            this.notEditable = this.contact.notEditable;
            if ( this.notEditable != true ) this.notEditable = undefined;
            
            if(this.contact.address.postalCode){
                  this.postalCode = this.contact.address.postalCode;
            }

            InputData.currentPageIdx = 15;
            if ( InputData.moveNext == 0 || InputData.moveNext == InputData.currentPageIdx ) this.timerService.isForwarding = false;
      }

      onPostalCodeChange() {
            this.isPostalCodeValid = '';
      }

      public verifyPostalCode() {

            if ( this.isCodeLookup ) return; 

            this.selectedRange = "";
            this.rangeList.clear();

            //validate first
            
            if (Util.isEmpty(this.postalCode)) {
                  this.error_postalCode = "contact_info_and_mailing_address.postalCodeEmpty";
                  return;
            } else if (!Util.postalCodeValidate(this.postalCode)) {

                  this.error_postalCode = "contact_info_and_mailing_address.PostalCodeInvalid";
                  return;
            }
            

            this.postalCodeParam = { postalCode: this.postalCode };
            this.isPostalCodeValid = '';
            this.canadaAddr.error_postal = '';

            this.isCodeLookup = true;
            //now do lookup
            this.postal.lookup(this.postalCode, (addr: MailAddressChoice[]) => {

                  this.isCodeLookup = false;
                  
                  if (!addr || addr.length == 0) {
                        this.isPostalCodeValid = '';
                        this.error_postalCode = 'contact_info_and_mailing_address.lookNotAvailable';
                        return;
                  }

                  this.contact.address.postalCode = this.postalCode;

                  if (addr != undefined && addr.length == 1) {
                        this.isPostalCodeValid = 'Y';
                        this.populateAddress(addr[0]);
                  } else if (addr.length > 1) {
                        this.isPostalCodeValid = 'Y';
                        this.availableList = addr;
                        this.availableList.forEach((element, index) => {
                              this.rangeList.set(String(index), element.description);
                        });
                        this.onMyClick();
                  } else {
                        this.isPostalCodeValid = 'N';
                  }
            });
      }

      public addressTypeChanged() {
            if (this.isCanadianAddress == "4100") {
                  this.data.motherContact.address.chk_international = 'Y';
            } else {
                  this.data.motherContact.address.chk_international = 'N';
            }

            this.clearPermanentAddress();
      }

      public chkIntChanged() {
            //clear all address and contact details.
            if (this.data.contact.address.chk_international == 'Y') {
                  this.data.contact.address.base.country = '';
            } else {
                  this.data.contact.address.base.country = Country.CANADA;
            }
            this.resetAddressAndContactDetails();
      }

      public ngOnInit() {
             super.forwardNext(this.data.eligibility.listedParentCount);
      }

      public onNextClick() : boolean {
             
            let success1: boolean = true;
            let success2: boolean = true;
            let success3: boolean = true;
            let success4: boolean = true;

            if (this.contact.address.chk_international == 'Y') {
                  this.internAddr.isCustodyOtherThanParent = false;
                  success1 = this.internAddr.validate();
            } else {
                  this.contact.address.base.country = Country.CANADA;
                  this.canadaAddr.isCustodyOtherThanParent = false;
                  success1 = this.canadaAddr.validate();
            }

            if (this.contact.isParentSameAddr == 'N') {
                  if (this.motherContact.address.chk_international == 'Y') {
                        success2 = this.parentInternAddr.validate();
                  } else {
                        this.motherContact.address.base.country = Country.CANADA;
                        success2 = this.parentCanadaAddr.validate();
                  }
            }

            success3 = this.addressValidator.validate();
            success4 = this.addressValidator.validate2(success1&&success2&&success3);

            if (success1 && success2 && success3 && success4) {
                  this.router.navigate([this.nextURL]);
            }
            return true;
      }

      public onMyClick() {
            this.list.update();
            this.box1.open();
      }

      public onMyClose() {
            if ( !this.selectedRange  ) {
                  ///nothing selected, don't close
                  this.error_selectRange = "contact_info_and_mailing_address.noAddressRangeSelected";
                  return;
            }
            let selected = this.availableList[this.selectedRange];
            this.box1.close();
            this.populateAddress(selected);
      }

      public populateAddress(selected: MailAddressChoice) {
            this.contact.address.unit = '';
            this.contact.address.chk_unitNA = false;
            this.contact.address.buzz = '';
            this.contact.address.chk_buzzNA = false;

            this.populateStreetNumber(selected);
            this.contact.address.streetName = selected.streetName;
            if (selected.streetType) this.contact.address.streetName += " " + selected.streetType;
            if (selected.streetDirection) this.contact.address.streetName += " " + selected.streetDirection;
            this.canadaAddr.error_streetName = '';

            this.contact.address.base.city = selected.municipality
            this.canadaAddr.error_city = '';
            this.contact.address.base.province = this.getProvinceCodeByName(selected.province);
            this.canadaAddr.error_province = '';
            this.contact.address.postalCode = selected.postalCode;
      }

      private populateStreetNumber(selected: MailAddressChoice) {
            if (!Util.isEmpty(selected.streetToNumber) && selected.streetToNumber === selected.streetFromNumber) {

                  let streetToNum = this.trimLeadingZeros(selected.streetToNumber);

                  if (streetToNum.length > 10) {
                        streetToNum = streetToNum.substring(0, 10);
                  }
                  this.contact.address.streetNumber = streetToNum;
                  this.canadaAddr.error_streetNumber = '';
            } else {
                  this.contact.address.streetNumber = '';
            }
      }

      private trimLeadingZeros(streetNum: string) {
            return (streetNum == null) ? '' : '' + Number.parseInt(streetNum);
      }

      private getProvinceCodeByName(provinceName: string): string {
            let prov = this.getProvinceCodeByName2(provinceName);

            return prov;
      }

      private getProvinceCodeByName2(provinceName: string): string {
            if (provinceName == 'AB') return '800';
            if (provinceName == 'BC') return '900';
            if (provinceName == 'MB') return '600';
            if (provinceName == 'NB') return '300';
            if (provinceName == 'NL') return '1200';
            if (provinceName == 'NT') return '1100';
            if (provinceName == 'NS') return '200';
            if (provinceName == 'NU') return '1300';
            if (provinceName == 'ON') return '500';
            if (provinceName == 'PE') return '100';
            if (provinceName == 'QC') return '400';
            if (provinceName == 'SK') return '700';
            if (provinceName == 'YT') return '1000';
            return provinceName;
      }

      resetAddressAndContactDetails(): void {
            this.postalCode = '';
            this.contact.address.unit = '';
            this.contact.address.chk_unitNA = false;
            this.contact.address.buzz = '';
            this.contact.address.chk_buzzNA = false;
            this.contact.address.poBox = '';
            this.contact.address.chk_poBox = false;

            this.contact.address.streetNumber = '';
            this.contact.address.streetName = '';
            this.contact.address.base.city = '';
            this.contact.address.base.province = '';
            this.contact.address.postalCode = '';


            this.isPostalCodeValid = '';
            this.canadaAddr.error_postal = '';
            this.error_postalCode = '';

            this.contact.phoneArea = '';
            this.contact.phoneNumber1 = '';
            this.contact.phoneNumber2 = '';
            this.contact.phoneExt = '';
            this.contact.daytimePhoneArea = '';
            this.contact.daytimePhoneNumber1 = '';
            this.contact.daytimePhoneNumber2 = '';
            this.contact.daytimeExt = '';

            this.canadaAddr.error_buzz = '';
            this.canadaAddr.error_unit = '';
            this.canadaAddr.error_city = '';
            this.canadaAddr.error_province = '';
            this.canadaAddr.error_streetName = '';
            this.canadaAddr.error_streetNumber = '';

            this.error_phoneNumber = '';
            this.error_daytimePhoneNumber = '';
            this.error_intDaytimePhoneNumber = '';
            this.error_intPhoneNumber = '';

            this.internAddr.error_city = '';
            this.internAddr.error_streetName = '';
            this.internAddr.error_streetNumber = '';
            this.internAddr.error_unit = '';
            this.internAddr.error_poBox = '';
            this.internAddr.error_province = '';
            this.internAddr.error_postal = '';
      }

      resetPermanentAddress(){
            this.clearPermanentAddress();
            this.isCanadianAddress = '';
            this.motherContact.address.chk_international = '';
      }

      clearPermanentAddress(){
            this.motherContact.address.streetName = ''
            this.motherContact.address.streetNumber = ''
            this.parentCanadaAddr.error_streetName = '';
            this.parentCanadaAddr.error_streetNumber = '';
            this.motherContact.address.base.city = ''
            this.parentCanadaAddr.error_city = '';
            this.motherContact.address.base.province = '';
            this.parentCanadaAddr.error_province = '';

            this.motherContact.address.postalCode = '';
            this.parentCanadaAddr.error_postal = '';

            this.motherContact.address.unit = '';
            this.motherContact.address.chk_unitNA = false;
            this.parentCanadaAddr.error_unit = '';

            this.motherContact.address.buzz = '';
            this.motherContact.address.chk_buzzNA = false;
            this.parentCanadaAddr.error_buzz = '';

            this.motherContact.address.poBox = '';
            this.motherContact.address.chk_poBox = false;
            this.parentCanadaAddr.error_poBox = '';

            this.motherContact.address.deliveryNeed = '';
            this.motherContact.address.deliveryAddr = '';
            this.motherContact.address.deliveryMode = '';
      }

}
